import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  faUsers,
  faClipboardList,
  faCalendarCheck,
  faDumbbell,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

import { MetricsCompactCarousel } from "./MetricsCompactCarousel";

/**
 * Compact player home metrics — horizontal snap strip (3 visible per snap).
 */
export const MetricsPlayerYear = ({ data }) => {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        key: "groups",
        icon: faUsers,
        label: t("playerMetricGroups", t("coachMetricGroups")),
        value: data?.playerGroupsCount ?? data?.totalGroups ?? 0,
        tone: "groups",
      },
      {
        key: "sessions",
        icon: faClipboardList,
        label: t("playerMetricSessionsDoneYear"),
        value: data?.sessionsPerformedThisYear ?? 0,
        tone: "sessions",
      },
      {
        key: "upcoming",
        icon: faCalendarCheck,
        label: t(
          "playerMetricSessionsUpcoming",
          t("playerMetricSessionsScheduledYear")
        ),
        value:
          data?.sessionsScheduledUpcoming ??
          data?.sessionsScheduledThisYear ??
          0,
        tone: "upcoming",
      },
      {
        key: "exercises",
        icon: faDumbbell,
        label: t("playerMetricExercises", t("presenceReportExercises", "Exercises")),
        value: data?.trainingExercisesExecuted ?? 0,
        tone: "players",
      },
      {
        key: "hours",
        icon: faClock,
        label: t("playerMetricLastWeekHours", "Last 7 days (h)"),
        value:
          data?.lastWeekTrainingHours != null
            ? Number(data.lastWeekTrainingHours).toFixed(1)
            : 0,
        tone: "sessions",
      },
    ],
    [data, t]
  );

  return <MetricsCompactCarousel items={items} />;
};
